export default function() {
    return {
        authUser: {},
        firebaseToken: null,
        firebaseAuthUser: {},
        firebaseUserData: {},
        setPassword: {
            password: "",
            password_confirmation: "",
            token: "",
        },
    }
}